require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-strategy-and-planning.json") })
        }
      }, "path---services-strategy-and-planning");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-strategy-and-planning!./.cache/json/services-strategy-and-planning.json
// module id = 1484
// module chunks = 231608221292675